import axios from "axios"

import apiUrl from "../apiConfig"

const USER_KEY = "user"

// paths where a 401 is an expected answer to a credential the user just typed,
// rather than a sign that their stored session died
const CREDENTIAL_PATHS = ["/sign-in", "/sign-up"]

// read the signed-in user back out of localStorage.
// a half-written or legacy value used to throw here and take the whole app
// down on boot, so treat anything unparseable as "not signed in"
export const getStoredUser = () => {
	try {
		return JSON.parse(localStorage.getItem(USER_KEY)) || null
	} catch (error) {
		localStorage.removeItem(USER_KEY)
		return null
	}
}

export const setStoredUser = (user) =>
	localStorage.setItem(USER_KEY, JSON.stringify(user))

// only remove our own key — `localStorage.clear()` would also wipe unrelated
// preferences like `tempMeasure`
export const clearStoredUser = () => localStorage.removeItem(USER_KEY)

let onUnauthorized = () => {}

// let App register what should happen when the server rejects our token
export const registerUnauthorizedHandler = (handler) => {
	onUnauthorized = handler
}

// sessions can now be revoked from another device or expire on their own, so
// any request can come back 401 even though the client still has a user in
// localStorage. drop the dead session instead of leaving a signed-in UI that
// fails every action.
export const installAuthInterceptor = () => {
	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			const status = error.response && error.response.status
			const url = (error.config && error.config.url) || ""
			const isCredentialAttempt = CREDENTIAL_PATHS.some((path) =>
				url.startsWith(apiUrl + path)
			)

			if (status === 401 && !isCredentialAttempt) {
				clearStoredUser()
				onUnauthorized()
			}

			return Promise.reject(error)
		}
	)
}
